import reducer from "./adminSlice";

export default reducer;